import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function writeAuditLog({
  entity,
  entityId,
  action,
  extra = {},
  uid = null,
  email = null,
  displayName = null,
  role = "unknown",
}) {
  await addDoc(collection(db, "auditLogs"), {
    entity,
    entityId,
    action,
    by: uid,
    byEmail: email,
    byName: displayName,
    role,
    extra,
    timestamp: serverTimestamp(),
  });
}
